import { Check } from "lucide-react";
import { IMAGES } from "../content";
import { Eyebrow, HudCorners, Reveal } from "./bits";

const Chapter = ({ ch, index }) => {
  const flip = index % 2 === 1;
  return (
    <Reveal className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center`}>
      <div className={flip ? "lg:order-2" : ""}>
        <div className="flex items-baseline gap-4 mb-4">
          <span className="font-mono-tech text-emerald text-base tracking-[0.3em]">{ch.num}</span>
          <span className="flex-1 h-px bg-[#CBD3DF]" />
        </div>
        <h3 className="font-display font-bold uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl text-[#0B0D10]">
          {ch.title}
        </h3>
        <p className="mt-5 text-base sm:text-lg leading-relaxed text-neutral-700">{ch.desc}</p>
        <ul className="mt-7 space-y-3">
          {ch.bullets.map((b, i) => (
            <li key={i} className="flex items-start gap-3 text-base text-neutral-800">
              <Check size={16} className="text-emerald mt-0.5 shrink-0" strokeWidth={3} />
              {b}
            </li>
          ))}
        </ul>
        <div className="mt-8 flex flex-wrap gap-2">
          {ch.specs.map((s, i) => (
            <span
              key={i}
              className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-emerald/80 border border-emerald/25 bg-emerald/5 px-3 py-1.5 rounded-sm"
            >
              {s}
            </span>
          ))}
        </div>
      </div>

      <div className={flip ? "lg:order-1" : ""}>
        <div className="group relative" data-testid={`capability-card-${ch.id}`}>
          <div className="relative overflow-hidden rounded-sm border border-[#CBD3DF] bg-[#FFFFFF]">
            <img
              src={IMAGES[ch.id]}
              alt={ch.title}
              loading="lazy"
              className="w-full aspect-[4/3] object-cover opacity-80 saturate-[0.7] transition-[transform,opacity,filter] duration-700 group-hover:scale-105 group-hover:opacity-100 group-hover:saturate-100"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#E9EDF3]/80 via-transparent to-transparent" />
            <div className="absolute bottom-4 left-4 font-mono-tech text-[10px] uppercase tracking-[0.25em] text-emerald/90 bg-[#E9EDF3]/70 backdrop-blur px-3 py-1.5 border border-emerald/25">
              {ch.num} // {ch.title}
            </div>
          </div>
          <HudCorners className="border-emerald/70 transition-all duration-500 group-hover:w-6 group-hover:h-6" />
        </div>
      </div>
    </Reveal>
  );
};

const Capabilities = ({ t }) => {
  return (
    <section id="capabilities" data-testid="capabilities-section" className="relative py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Eyebrow>{t.eyebrow}</Eyebrow>
          <h2 className="mt-5 font-display font-bold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#0B0D10]">
            {t.title}
          </h2>
          <p className="mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-neutral-700">{t.subtitle}</p>
        </Reveal>

        <div className="mt-20 space-y-24 lg:space-y-32">
          {t.chapters.map((ch, i) => (
            <Chapter key={ch.id} ch={ch} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Capabilities;
